export default __webpack_public_path__ + "KaTeX_Fraktur-Regular.96556db6d8effe29a581028d82c1ac04.ttf";